import React from 'react';
import PropTypes from 'prop-types';
import { Button, FormControl, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { find, get } from 'lodash';

import SegmentListItem from './SegmentListItem';
import { deleteAudienceSegment } from '../../actions/audience-segment-actions';
import { defaultActionsForMapDispatchToProps } from '../../utils/redux';

class SegmentsList extends React.Component {
  state = {
    selected: {},
    confirmDelete: false,
    uuidToDelete: '',
    searchFilter: ''
  };

  selectSegment = uuid => {
    const segment = find(this.props.segments, s => s.uuid === uuid);
    if (uuid === this.state.selected.uuid) {
      this.setState({ selected: {} });
    } else if (segment) {
      this.setState({ selected: segment });
    }
  };

  applySegment = async () => {
    this.props.handleApply(this.state.selected);
  };

  confirmDeleteSegment = uuid => {
    this.setState({
      confirmDelete: true,
      uuidToDelete: uuid
    });
  };

  deleteSegment = () => {
    this.props.onClickDeleteSegment(this.state.uuidToDelete);
    this.setState({
      confirmDelete: false,
      uuidToDelete: ''
    });
  };

  updateSegmentList = e => {
    this.setState({
      searchFilter: e.target.value.toLowerCase()
    });
  };

  closeDeleteModal = () => {
    this.setState({
      confirmDelete: false,
      uuidToDelete: ''
    });
  };

  render() {
    const selectedUUID = get(this, ['state', 'selected', 'uuid'], '');
    return (
      <React.Fragment>
        <div className="tvt-audience-segment__header">
          <div className="tvt-audience-segment__header-title">Segments</div>
          <Button
            className="tvt-audience-segment__button tvt-audience-segment__create-button"
            onClick={this.props.openCreate}
          >
            Create new
          </Button>
          <FormControl
            type="tvt-audience-segment__search"
            placeholder="Search Segments"
            className="tvt-audience-segment__searchbar"
            onChange={this.updateSegmentList}
          />
        </div>
        <div className="tvt-audience-segment__segment-list-header">
          <div className="tvt-audience-segment__segment-list-column-name">
            Segment Name
          </div>
          <div className="tvt-audience-segment__segment-list-column-created">
            Created
          </div>
          <div className="tvt-audience-segment__segment-list-column-modified">
            Modified
          </div>
          <div className="tvt-audience-segment__segment-list-column-edit" />
          <div className="tvt-audience-segment__segment-list-column-delete" />
        </div>
        <div className="tvt-audience-segment__segment-list">
          {this.props.segments
            .filter(s => s.name.toLowerCase().includes(this.state.searchFilter))
            .map((segment, index) => {
              const bgColor = index % 2 !== 0;
              return (
                <SegmentListItem
                  key={segment.uuid}
                  confirmDeleteSegment={this.confirmDeleteSegment}
                  selectSegment={this.selectSegment}
                  isSelected={selectedUUID === segment.uuid}
                  handleEdit={this.props.handleEdit}
                  bgColor={bgColor}
                  index={index}
                  {...segment}
                />
              );
            })}
        </div>
        <div className="tvt-audience-segment__segment-footer">
          <Button
            onClick={this.applySegment}
            className="tvt-audience-segment__button tvt-audience-segment__save-button"
            disabled={Object.keys(this.state.selected).length < 1}
          >
            Apply
          </Button>
          <Button
            onClick={this.props.onClose}
            className="tvt-audience-segment__button tvt-audience-segment__list-cancel-button"
          >
            Cancel
          </Button>
        </div>
        <Modal
          className="tvt-audience-segment__confirm-delete-modal"
          show={this.state.confirmDelete}
        >
          <Modal.Header>
            Are you sure you want to delete this segment?
          </Modal.Header>
          <Modal.Body>
            <Button
              className="tvt-audience-segment__button tvt-audience-segment__list-cancel-button"
              onClick={this.closeDeleteModal}
            >
              Cancel
            </Button>
            <Button
              className="tvt-audience-segment__button tvt-audience-segment__confirm-delete-button"
              onClick={this.deleteSegment}
              variant="danger"
            >
              Delete
            </Button>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}

SegmentsList.propTypes = {
  segments: PropTypes.shape([]),
  onClose: PropTypes.func.isRequired,
  handleEdit: PropTypes.func.isRequired,
  openCreate: PropTypes.func.isRequired
};

SegmentsList.defaultProps = {
  segments: []
};

const defaultActions = {
  onClickDeleteSegment: deleteAudienceSegment
};

const mapStateToProps = null;
const mapDispatchToProps = defaultActionsForMapDispatchToProps(defaultActions);

export default connect(mapStateToProps, mapDispatchToProps)(SegmentsList);
